// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see FormBlockerInteractStartEvent
 */
export var FormBlockerInteractStart = function (_a) {
    var blockerId = _a.blockerId, elementId = _a.elementId;
    return ({
        name: "FormBlocker Interact Start",
        parameters: {
            cdf_entity: "FormBlocker",
            cdf_action: "Interact",
            blockerId: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            elementId: elementId !== undefined && elementId !== null ? elementId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FormBlockerInteractTapEvent
 */
export var FormBlockerInteractTap = function (_a) {
    var blockerId = _a.blockerId, elementId = _a.elementId;
    return ({
        name: "FormBlocker Interact Tap",
        parameters: {
            cdf_entity: "FormBlocker",
            cdf_action: "Interact",
            blockerId: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            elementId: elementId !== undefined && elementId !== null ? elementId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FormBlockerLaunchCancelEvent
 */
export var FormBlockerLaunchCancel = function (_a) {
    var blockerId = _a.blockerId, elementId = _a.elementId;
    return ({
        name: "FormBlocker Launch Cancel",
        parameters: {
            cdf_entity: "FormBlocker",
            cdf_action: "Launch",
            blockerId: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            elementId: elementId !== undefined && elementId !== null ? elementId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see FormBlockerLaunchShowEvent
 */
export var FormBlockerLaunchShow = function (_a) {
    var blockerId = _a.blockerId, clientScenario = _a.clientScenario, flowToken = _a.flowToken, uniqueElementNames = _a.uniqueElementNames, elementCount = _a.elementCount;
    return ({
        name: "FormBlocker Launch Show",
        parameters: {
            cdf_entity: "FormBlocker",
            cdf_action: "Launch",
            blockerId: blockerId !== undefined && blockerId !== null ? blockerId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            client_scenario: clientScenario !== undefined && clientScenario !== null ? clientScenario.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            unique_element_names: uniqueElementNames !== undefined && uniqueElementNames !== null ? uniqueElementNames.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            element_count: elementCount !== undefined && elementCount !== null ? elementCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
